import { QuestionExplanation } from '../../types'

export const GETALBEGRIP_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'GET-POS-L1-001': {
    id: 'GET-POS-L1-001',
    explanation:
      'De 8 staat op de plek van de duizendtallen. Dus de 8 betekent 8.000.',
    distractorExplanations: {
      '0': 'Dat zijn de tientallen (de 3).',
      '1': 'Dat zijn de honderdtallen (de 4).',
      '3': 'Dat zijn de tienduizendtallen (de 7).',
    },
  },
  'GET-VER-L1-001': {
    id: 'GET-VER-L1-001',
    explanation: '0,75 is driekwart. Dat schrijf je als $\\frac{3}{4}$.',
    distractorExplanations: {
      '0': 'Dat is de helft (0,50).',
      '1': 'Dat is een kwart (0,25).',
      '3': 'Dat is 0,40.',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 3,
        denominator: 4,
        label: '3 van de 4 stukken',
        visualType: 'pizza',
        usePizza: true,
      },
      showWhen: 'always',
    },
  },
  'GET-VER-L1-002': {
    id: 'GET-VER-L1-002',
    explanation:
      'De onderkant (noemer) blijft hetzelfde. Tel alleen de bovenkant (teller) op: 2 + 1 + 1 = 4. Dus $\\frac{4}{5}$.',
    distractorExplanations: {
      '0': 'Je hebt de onderkant ook opgeteld (5 + 5 + 5). Dat mag niet! De onderkant blijft 5.',
      '2': 'Je bent er twee vergeten. Tel alle bovenkantjes op: 2 + 1 + 1 = 4.',
      '3': '$\\frac{4}{5}$ is nog geen hele. Een hele is $\\frac{5}{5}$!',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 4,
        denominator: 5,
        label: '4 van de 5 stukken',
        visualType: 'chocolate',
        usePizza: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-VER-L1-003': {
    id: 'GET-VER-L1-003',
    explanation:
      'Een hele taart is $\\frac{4}{4}$. Je eet $\\frac{1}{4}$ op. Dan blijft er over: $\\frac{4}{4}$ - $\\frac{1}{4}$ = $\\frac{3}{4}$.',
    distractorExplanations: {
      '1': 'Dit is het stukje dat je hebt opgegeten! De vraag is: hoeveel blijft er over?',
      '2': 'De helft is $\\frac{2}{4}$. Maar er blijft meer over dan de helft!',
      '3': 'De onderkant (noemer) verandert niet. En $\\frac{4}{3}$ is meer dan 1 hele taart!',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 3,
        denominator: 4,
        label: '3 van de 4 stukken zijn over',
        visualType: 'cake',
        usePizza: true,
      },
      showWhen: 'always',
    },
  },
  'GET-VER-L1-004': {
    id: 'GET-VER-L1-004',
    explanation:
      'De onderkant is hetzelfde (beide 5). Tel alleen de bovenkant op: 2 + 1 = 3. Dus $\\frac{3}{5}$.',
    distractorExplanations: {
      '1': 'Je hebt de onderkant ook opgeteld (5 + 5 = 10). Maar de onderkant blijft gewoon 5!',
      '2': 'Je hebt vermenigvuldigd. Maar bij breuken optellen tel je de bovenkant op.',
      '3': 'Je hebt afgetrokken. Maar er staat een plusteken (+)!',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 3,
        denominator: 5,
        label: '3 van de 5 stukken',
        visualType: 'chocolate',
        usePizza: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-VER-L2-001': {
    id: 'GET-VER-L2-001',
    explanation:
      '$\\frac{1}{4}$ betekent: deel door 4. Dus: 20 : 4 = 5 rode knikkers.',
    distractorExplanations: {
      '1': 'Je hebt naar het getal 4 gekeken. Maar $\\frac{1}{4}$ betekent: deel door 4!',
      '2': 'Dit is de helft ($\\frac{1}{2}$). Maar een kwart is minder dan de helft!',
      '3': 'Dit zijn de knikkers die NIET rood zijn ($\\frac{3}{4}$ van 20).',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 1,
        denominator: 4,
        label: '1 van de 4 delen = 5 knikkers',
        visualType: 'pizza',
        usePizza: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-VER-L2-002': {
    id: 'GET-VER-L2-002',
    explanation:
      'Er komt steeds een half ($\\frac{1}{2}$) bij. Kijk: anderhalf + een half = 2.',
    distractorExplanations: {
      '1': 'Je deed er een kwart ($\\frac{1}{4}$) bij. Maar de stapjes zijn een half ($\\frac{1}{2}$)!',
      '2': 'Je sloeg een getal over. Tel rustig: $\\frac{1}{2}$, 1, 1$\\frac{1}{2}$, 2...',
      '3': 'Je deed er een hele bij. Maar de stapjes zijn een half!',
    },
    visualAid: {
      type: 'numberline',
      data: {
        start: 0,
        end: 3,
        highlight: [0.5, 1, 1.5, 2],
        label: 'Getallenlijn: +0,5 per stap',
      },
      showWhen: 'wrong',
    },
  },
  'GET-VER-L3-001': {
    id: 'GET-VER-L3-001',
    explanation: '50% is precies de helft. De helft van 200 is 100.',
    distractorExplanations: {
      '1': 'Je hebt het getal 50 genomen. Maar 50% betekent: de helft!',
      '2': 'Dit is 10% (een tiende deel).',
      '3': 'Dit is 75% (driekwart).',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 1,
        denominator: 2,
        label: '50% = de helft',
        visualType: 'pizza',
        usePizza: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-VER-L3-002': {
    id: 'GET-VER-L3-002',
    explanation:
      'Eerst reken je een kwart uit: 40 : 4 = 10. Ze heeft 3 kwarten, dus: 3 $\\times$ 10 = 30 euro.',
    distractorExplanations: {
      '1': 'Dit is maar één kwart! Ze heeft al drie kwarten gespaard.',
      '2': 'Dit is de helft. Maar driekwart is meer dan de helft!',
      '3': 'Reken stap voor stap: eerst 40 : 4 = 10, dan 10 $\\times$ 3 = 30.',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 3,
        denominator: 4,
        label: '3 van de 4 delen = €30',
        visualType: 'chocolate',
        usePizza: true,
      },
      showWhen: 'wrong',
    },
  },

  // Kolomsgewijs aftrekken
  'GET-AFT-L1-001': {
    id: 'GET-AFT-L1-001',
    explanation:
      'Reken kolomsgewijs: 5 - 3 = 2 (eenheden), 4 - 2 = 2 (tientallen). Dus 22.',
    distractorExplanations: {
      '1': 'Je hebt de cijfers door elkaar gehaald. Begin rechts bij de eenheden!',
      '2': 'Rekenfoutje. Check: 45 - 23 = 22.',
      '3': 'Je hebt opgeteld in plaats van afgetrokken!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Kolomsgewijs Aftrekken',
        content:
          'Begin altijd rechts bij de eenheden. Trek kolom voor kolom af: eerst eenheden, dan tientallen.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'GET-AFT-L1-002': {
    id: 'GET-AFT-L1-002',
    explanation:
      'Reken kolomsgewijs: 8 - 4 = 4 (eenheden), 7 - 3 = 4 (tientallen). Dus 44.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij de tientallen. 7 - 3 = 4, niet 5.',
      '2': 'Je hebt de cijfers door elkaar gehaald.',
      '3': 'Check je berekening nog eens: 78 - 34 = 44.',
    },
  },
  'GET-AFT-L2-001': {
    id: 'GET-AFT-L2-001',
    explanation:
      'Je kunt 7 niet van 2 afhalen. Dus leen je 1 van de 5 (wordt 4). Nu wordt 2 → 12. Dan: 12 - 7 = 5 (eenheden), 4 - 2 = 2 (tientallen). Dus 25.',
    distractorExplanations: {
      '1': 'Je bent vergeten te lenen! 2 is kleiner dan 7, dus je moet lenen.',
      '2': 'Rekenfoutje. Check je lenen: 12 - 7 = 5.',
      '3': 'Je hebt verkeerd geleend. Probeer het stapje voor stapje.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Lenen bij Aftrekken',
        content:
          'Als het bovenste cijfer kleiner is, leen je 1 van de volgende kolom. Die 1 is 10 waard!',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'GET-AFT-L2-002': {
    id: 'GET-AFT-L2-002',
    explanation:
      'Lenen! 3 is kleiner dan 8. Leen 1 van de 8 (wordt 7). Nu: 13 - 8 = 5 (eenheden), 7 - 4 = 3 (tientallen). Dus 35.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij het lenen. Check: 13 - 8 = 5.',
      '2': 'Je bent vergeten te lenen bij de tientallen.',
      '3': 'Oeps, rekenfout. Probeer het nog eens stap voor stap.',
    },
  },
  'GET-AFT-L2-003': {
    id: 'GET-AFT-L2-003',
    explanation:
      'Lenen! 4 < 7, dus leen. 14 - 7 = 7 (eenheden). Dan 1 < 6, dus weer lenen. 11 - 6 = 5 (tientallen). Dus 57.',
    distractorExplanations: {
      '1': 'Je hebt te veel afgetrokken. Check je lenen goed.',
      '2': 'Rekenfout. Je moet twee keer lenen!',
      '3': 'Oeps, probeer het nog eens. 124 - 67 = 57.',
    },
  },
  'GET-AFT-L3-001': {
    id: 'GET-AFT-L3-001',
    explanation:
      'Let op de 0! 3 - 8 kan niet, leen van 0. Maar 0 heeft niks, dus leen van 5. Nu: 13 - 8 = 5, 9 - 4 = 5, 4 - 2 = 2. Dus 255.',
    distractorExplanations: {
      '1': 'Rekenfout bij het lenen door de 0 heen.',
      '2': 'Je hebt verkeerd geleend. Let op de 0!',
      '3': 'Te veel afgetrokken. Check je lenen stap voor stap.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Lenen door een 0',
        content:
          'Als er een 0 staat, moet je verder lenen! De 0 wordt 9, en je leent van het cijfer ervoor.',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'GET-AFT-L3-002': {
    id: 'GET-AFT-L3-002',
    explanation:
      '1000 - 387: Leen door alle nullen! 10 - 7 = 3, 9 - 8 = 1, 9 - 3 = 6. Dus 613.',
    distractorExplanations: {
      '1': 'Rekenfout. Check je lenen door de nullen.',
      '2': 'Oeps, probeer het nog eens. 1000 - 387 = 613.',
      '3': 'Te weinig afgetrokken. Controleer je berekening.',
    },
  },
  'GET-AFT-L3-003': {
    id: 'GET-AFT-L3-003',
    explanation:
      '2004 - 1568: Leen waar nodig. 14 - 8 = 6, 9 - 6 = 3, 9 - 5 = 4, 1 - 1 = 0. Dus 436.',
    distractorExplanations: {
      '1': 'Rekenfout bij het lenen.',
      '2': 'Check je berekening nog eens.',
      '3': 'Oeps, probeer het stap voor stap opnieuw.',
    },
  },

  // Breuken vergelijken
  'GET-VGL-L1-001': {
    id: 'GET-VGL-L1-001',
    explanation:
      '$\\frac{1}{2}$ is groter dan $\\frac{1}{4}$. Een half is groter dan een kwart. Denk aan een pizza: een half is 2 stukken van 4, een kwart is maar 1 stuk.',
    distractorExplanations: {
      '1': 'Een kwart is kleiner dan een half!',
      '2': 'Ze zijn niet even groot. Een half is twee keer zo groot als een kwart.',
      '3': 'Je kunt het wel zeggen! Vergelijk de stukken.',
    },
    visualAid: {
      type: 'fraction',
      data: {
        numerator: 1,
        denominator: 2,
        label: '1/2 is groter dan 1/4',
        visualType: 'pizza',
        usePizza: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-VGL-L1-002': {
    id: 'GET-VGL-L1-002',
    explanation:
      '$\\frac{2}{5}$ is kleiner. Als de bovenkant hetzelfde is (beide 2), kijk naar de onderkant. Hoe groter de onderkant, hoe kleiner de stukken!',
    distractorExplanations: {
      '1': '$\\frac{2}{3}$ is juist groter! 2 van de 3 is meer dan 2 van de 5.',
      '2': 'Ze zijn niet even groot. $\\frac{2}{3}$ is groter.',
      '3': 'Je kunt het wel vergelijken! Kijk naar de onderkant.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Breuken Vergelijken',
        content:
          'Als de bovenkant hetzelfde is: hoe groter de onderkant, hoe kleiner de breuk!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'GET-VGL-L2-001': {
    id: 'GET-VGL-L2-001',
    explanation:
      'Van klein naar groot: $\\frac{1}{4}$ (kleinste stukken), $\\frac{1}{3}$ (middelste), $\\frac{1}{2}$ (grootste). Hoe groter de onderkant, hoe kleiner de stukken!',
    distractorExplanations: {
      '1': 'Dit is van groot naar klein! De vraag is van klein naar groot.',
      '2': 'Niet helemaal. $\\frac{1}{4}$ is het kleinst, niet $\\frac{1}{3}$.',
      '3': 'Ze zijn niet allemaal even groot!',
    },
  },
  'GET-VGL-L2-002': {
    id: 'GET-VGL-L2-002',
    explanation:
      '$\\frac{3}{4}$ is groter. Maak ze gelijk: $\\frac{3}{4}$ = $\\frac{6}{8}$. En $\\frac{6}{8}$ is groter dan $\\frac{5}{8}$.',
    distractorExplanations: {
      '1': '$\\frac{5}{8}$ is kleiner! $\\frac{3}{4}$ = $\\frac{6}{8}$, en dat is meer.',
      '2': 'Ze zijn niet even groot. $\\frac{3}{4}$ is iets groter.',
      '3': 'Je kunt het wel vergelijken! Maak de onderkant gelijk.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Gelijknamig Maken',
        content:
          'Maak de onderkant gelijk om te vergelijken. 3/4 = 6/8, dus 6/8 > 5/8.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'GET-VGL-L3-001': {
    id: 'GET-VGL-L3-001',
    explanation:
      '$\\frac{3}{8}$ ligt precies tussen $\\frac{1}{4}$ en $\\frac{1}{2}$. Maak gelijk: $\\frac{1}{4}$ = $\\frac{2}{8}$ en $\\frac{1}{2}$ = $\\frac{4}{8}$. Dus $\\frac{3}{8}$ zit ertussen!',
    distractorExplanations: {
      '1': '$\\frac{2}{6}$ = $\\frac{1}{3}$, dat is iets te groot.',
      '2': '$\\frac{1}{3}$ ligt er iets boven.',
      '3': '$\\frac{2}{5}$ ligt er ook niet precies tussen.',
    },
  },
  'GET-VGL-L3-002': {
    id: 'GET-VGL-L3-002',
    explanation:
      'Van groot naar klein: $\\frac{5}{6}$ (grootste), $\\frac{3}{4}$ = $\\frac{9}{12}$, $\\frac{2}{3}$ = $\\frac{8}{12}$ (kleinste). Maak de onderkant gelijk om te vergelijken!',
    distractorExplanations: {
      '1': 'Niet helemaal. $\\frac{5}{6}$ is het grootst, dat klopt!',
      '2': 'Dit is van klein naar groot! De vraag is van groot naar klein.',
      '3': 'Bijna! Maar $\\frac{3}{4}$ is groter dan $\\frac{2}{3}$.',
    },
  },

  // ✅ MIGRATED TO INDEX-BASED: Kolomsgewijs optellen - distractors now use INDEX keys
  'GET-OPT-L1-001': {
    id: 'GET-OPT-L1-001',
    explanation:
      'Reken kolomsgewijs, van rechts naar links.\nEerst de eenheden: 3 + 5 = 8. Schrijf de 8 op.\nDan de tientallen: 2 + 4 = 6. Schrijf de 6 op.\nHet antwoord is 68.',
    distractorExplanations: {
      '1': 'Je hebt de cijfers door elkaar gehaald. Begin rechts bij de eenheden!',
      '2': 'Rekenfoutje. Check: 3 + 5 = 8, en 2 + 4 = 6.',
      '3': 'Bijna! Maar 2 + 4 = 6, niet 7.',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 23,
        operand2: 45,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-OPT-L1-002': {
    id: 'GET-OPT-L1-002',
    explanation:
      'Reken kolomsgewijs, van rechts naar links.\nEerst de eenheden: 4 + 2 = 6. Schrijf de 6 op.\nDan de tientallen: 3 + 5 = 8. Schrijf de 8 op.\nHet antwoord is 86.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij de tientallen. 3 + 5 = 8, niet 7.',
      '2': 'Je hebt de cijfers door elkaar gehaald.',
      '3': 'Check je berekening nog eens: 34 + 52 = 86.',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 34,
        operand2: 52,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-OPT-L2-001': {
    id: 'GET-OPT-L2-001',
    explanation:
      'Reken kolomsgewijs met overhouden.\nEenheden: 7 + 8 = 15. Schrijf 5 op, onthoud 1.\nTientallen: 4 + 3 = 7, plus 1 (onthouden) = 8.\nHet antwoord is 85.',
    distractorExplanations: {
      '1': 'Je bent vergeten de 1 die je onthield erbij te tellen! 4 + 3 = 7, plus 1 onthouden = 8.',
      '2': 'Rekenfoutje bij het overhouden. Check: 7 + 8 = 15, schrijf 5 op en onthoud 1.',
      '3': 'Te weinig. Check je berekening: 47 + 38 = 85.',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 47,
        operand2: 38,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-OPT-L2-002': {
    id: 'GET-OPT-L2-002',
    explanation:
      'Reken kolomsgewijs met overhouden.\nEenheden: 6 + 7 = 13. Schrijf 3 op, onthoud 1.\nTientallen: 5 + 8 = 13, plus 1 = 14. Schrijf 4 op, onthoud 1.\nHonderdtallen: 1 + 2 = 3, plus 1 = 4.\nHet antwoord is 443.',
    distractorExplanations: {
      '1': 'Je bent vergeten de 1 die je onthield bij de honderdtallen erbij te tellen! 1 + 2 = 3, plus 1 onthouden = 4.',
      '2': 'Rekenfoutje bij het overhouden. Check elke kolom goed!',
      '3': 'Te weinig. Check: 156 + 287 = 443.',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 156,
        operand2: 287,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-OPT-L2-003': {
    id: 'GET-OPT-L2-003',
    explanation:
      'Reken kolomsgewijs met overhouden.\nEenheden: 7 + 5 = 12. Schrijf 2 op, onthoud 1.\nTientallen: 6 + 8 = 14, plus 1 (onthouden) = 15. Schrijf 5 op, onthoud 1.\nHonderdtallen: 2 + 1 = 3, plus 1 (onthouden) = 4.\nHet antwoord is 452.',
    distractorExplanations: {
      '1': 'Je bent vergeten de 1 die je onthield bij de honderdtallen erbij te tellen! 2 + 1 = 3, plus 1 onthouden = 4.',
      '2': 'Rekenfoutje bij het overhouden. Check: 7 + 5 = 12, schrijf 2 op en onthoud 1.',
      '3': 'Te weinig. Dit is een optelsom, geen aftreksom!',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 267,
        operand2: 185,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-OPT-L3-001': {
    id: 'GET-OPT-L3-001',
    explanation:
      'Grote getallen kolomsgewijs optellen met meerdere keren overhouden.\nEenheden: 7 + 6 = 13. Schrijf 3, onthoud 1.\nTientallen: 4 + 5 = 9, plus 1 = 10. Schrijf 0, onthoud 1.\nHonderdtallen: 8 + 9 = 17, plus 1 = 18. Schrijf 8, onthoud 1.\nDuizendtallen: 1 + 2 = 3, plus 1 = 4.\nHet antwoord is 4.803.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij het overhouden. Check elke kolom goed! Let op: 4 + 5 + 1 (onthouden) = 10, schrijf 0 op.',
      '2': 'Je bent een keer vergeten de onthouden 1 erbij te tellen.',
      '3': 'Oeps, rekenfout bij de duizendtallen. 1 + 2 = 3, plus 1 onthouden = 4.',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 1847,
        operand2: 2956,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-OPT-L3-002': {
    id: 'GET-OPT-L3-002',
    explanation:
      'Grote getallen kolomsgewijs optellen met meerdere keren overhouden.\nEenheden: 6 + 9 = 15. Schrijf 5, onthoud 1.\nTientallen: 5 + 8 = 13, plus 1 = 14. Schrijf 4, onthoud 1.\nHonderdtallen: 4 + 7 = 11, plus 1 = 12. Schrijf 2, onthoud 1.\nDuizendtallen: 3 + 2 = 5, plus 1 = 6.\nHet antwoord is 6.245.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij het overhouden. Check elke kolom goed!',
      '2': 'Je bent een keer vergeten de onthouden 1 erbij te tellen bij de honderdtallen!',
      '3': 'Oeps, rekenfout bij de duizendtallen. 3 + 2 = 5, plus 1 onthouden = 6.',
    },
    visualAid: {
      type: 'column',
      data: {
        operation: 'add',
        operand1: 3456,
        operand2: 2789,
        showSteps: true,
      },
      showWhen: 'wrong',
    },
  },
  'GET-AFT-L2-004': {
    id: 'GET-AFT-L2-004',
    explanation:
      'Kolomsgewijs aftrekken met lenen in meerdere kolommen.\nEenheden: 4 < 8, dus leen! 14 - 8 = 6.\nTientallen: 2 werd 1 (geleend), en 1 < 5, dus weer lenen! 11 - 5 = 6.\nHonderdtallen: 3 werd 2 (geleend). 2 - 1 = 1.\nHet antwoord is 166.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij het lenen. Check: 14 - 8 = 6, en 11 - 5 = 6.',
      '2': 'Je hebt te veel afgetrokken. Probeer het stap voor stap opnieuw.',
      '3': 'Oeps, rekenfout bij het lenen door meerdere kolommen.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Lenen in Meerdere Kolommen',
        content:
          'Als je moet lenen, vergeet niet dat de kolom waar je van leent 1 minder wordt! Check elke stap.',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'GET-CONTEXT-L3-001': {
    id: 'GET-CONTEXT-L3-001',
    explanation:
      'Eerst tel je alle knikkers op: 24 + 18 + 30 = 72 knikkers.\nDan trek je de weggegeven knikkers eraf: 72 - 15 = 57 knikkers.',
    distractorExplanations: {
      '1': 'Je hebt alleen de eerste twee zakken opgeteld. Tel alle drie de zakken op!',
      '2': 'Dit is het totaal aantal knikkers. Maar Lisa geeft er 15 weg!',
      '3': 'Je hebt verkeerd gerekend. Check: 24 + 18 + 30 = 72, dan 72 - 15 = 57.',
    },
  },
}
